/* tslint:disable */
import { Injectable } from '@angular/core';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { Observable as __Observable, throwError as __throwError, Observable, BehaviorSubject, of, EMPTY } from 'rxjs';
import { map as __map, filter as __filter, catchError as __catchError, tap, catchError, shareReplay, map, take } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { MemberService } from './member.service';
import { MerchantService } from './merchant.service'
import { Member } from '../models/member';
import * as firebase from 'firebase'
import { AngularFireAuth } from '@angular/fire/auth';
import { RecentChat } from '../models/recent_chats';

@Injectable({
  providedIn: 'root'
})

export class RecentChatService {

  private collectionName = 'recent_chats';
  memberChat$ : __Observable<any>;
  MemberRecentChats$: Observable<RecentChat[]>

  constructor(private firestore: AngularFirestore,
    private memberService: MemberService,
    private merchantService: MerchantService,
    public readonly afAuth: AngularFireAuth,) {
    }
    
  checkChatExists(field_type, field_value, field_type2, field_value2, type: string, field_type3, field_value3){
    return this.firestore.collection(this.collectionName, ref => ref
      .where(field_type, '==', field_value)
      .where(field_type2, '==', field_value2)
      .where(field_type3, '==', field_value3)
      .where('type', '==', type))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const chat = a.payload.doc.data() as any;
          chat.id = a.payload.doc.id;
          return chat;
        })
      }))
  }

  checkChatExistsForOrder(order_id) {
    return this.firestore.collection(this.collectionName, ref => ref
      .where('order_id', '==', order_id)
      .where('merchant_id', '==', this.merchantService.merchant.id)
      .where('type', '==', 'order')
      .orderBy("updated_at", 'desc'))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const chat = a.payload.doc.data() as any;
          chat.id = a.payload.doc.id;
          return chat;
        })
      }))
  }

  chatByLocation(filterKey) {
    this.memberChat$ = this.firestore.collection(this.collectionName, ref => ref
        .where('location_id', '==', filterKey)
        .where('type', '==', 'merchant')
        .orderBy("updated_at", "desc")).snapshotChanges()
        .pipe(map(actions => {
            return actions.map(a => {
                const chat = a.payload.doc.data() as any;
                chat.id = a.payload.doc.id;
                if (chat.member_id != null) {
                    this.memberService.memberById(chat.member_id).subscribe((memRes: Member) => {
                        if (memRes) {
                            chat.member = memRes
                        }
                    })
                }
                return chat
            });
        }));
        return this.memberChat$;
  }


  recentChatCreate(item): Promise<any> {
    return new Promise((resolve, reject) => {
      this.firestore.collection(this.collectionName).add(item).then(res => {
        resolve(res);
      }).catch(err => {
        console.log("mce", err.message);
      })
    });
  }

  recentChatUpdate(item): Promise<any> {
    const id = item.id;
    delete item.id;
    item.updated_at = firebase.firestore.FieldValue.serverTimestamp()
    return new Promise((resolve, reject) => {
      this.firestore.collection(this.collectionName).doc(id).update(item).then(res => {
        resolve(res);
      }, err => {
        reject(err);
      })
    });
  }

  returnRecentChats(key: string, res_uid: string, type: string) {
    return this.firestore.collection(this.collectionName, ref => ref
      .where(key, '==', res_uid)
      .where('type', '==', type)
      .orderBy('updated_at', "desc"))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const chat = a.payload.doc.data() as any;
          chat.id = a.payload.doc.id;
          return chat;
        })
      }))
  }

  listMemberRecentChats(): Observable<RecentChat[]> {
    this.MemberRecentChats$ = this.firestore.collection(this.collectionName, ref => ref
      .where('member_id', '==', this.afAuth.auth.currentUser.uid)
      // .where('type', '==', type)
      .orderBy('updated_at', "desc")
    )
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const chat = a.payload.doc.data() as any;
          chat.id = a.payload.doc.id;
          return chat;
        })
      }))
    return this.MemberRecentChats$
  }
}

